import { Component, inject } from '@angular/core';
import packageJson from '../../../../package.json';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import {
  selectShowSaveButton,
  selectSaveStatus,
  selectDisableSaveButton,
  selectIsSubmitted,
} from 'src/app/state/form.selectors';
import { Status } from 'src/app/models/Status';
import { Observable } from 'rxjs';
import { saveQr } from 'src/app/state/form.actions';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [NgClass, AsyncPipe, TranslatePipe],
})
export class HeaderComponent {
  private readonly store = inject(Store);

  saveStatus$: Observable<Status> = this.store.select(selectSaveStatus);
  showSaveButton$: Observable<boolean> =
    this.store.select(selectShowSaveButton);
  disableSaveButton$: Observable<boolean> = this.store.select(
    selectDisableSaveButton,
  );
  isSubmitted$: Observable<boolean> = this.store.select(selectIsSubmitted);

  versionStr = `Smile DTR Client (v${packageJson.version} SaaS)`;
  logo = environment.logo;

  saveQr() {
    this.store.dispatch(saveQr());
  }
}
